export default __webpack_public_path__ + "static/media/drum-sprite-full.f1f2ce49.wav";